import { createRouter, createWebHistory } from "vue-router";

import Main from "./pages/Main.vue";
import VenueOverviewParent from "./pages/VenueOverview/VenueOverviewParent.vue";
import ServiceVenueOverviewParent
    from "./pages/Services/ServiceVenueOverviewParent.vue";
import EventSeriesParent from "./pages/EventSeriesParent.vue";
import AdvancedCourseParent from "./pages/AdvancedCourseParent.vue";

const path = "/management-panel";

const routes = [
    {
        path,
        name: "Main",
        component: Main,
    },
    {
        path: `${path}/advanced`,
        name: "Advanced",
        component: Main,
        children: [
            {
                path: `${path}/advanced/:termdateId/:venueId?/:weekday?`,
                name: "Advanced term",
                component: AdvancedCourseParent,
            },
            {
                path: `${path}/advanced/:venueId/:actId/:termId/:sessionId/:weekday?`,
                name: "Advanced event series",
                component: EventSeriesParent,
            },
        ],
    },
    {
        path: `${path}/simple`,
        name: "Simple",
        component: Main,
        children: [
            {
                path: ":venueId",
                name: "Simple venue",
                component: VenueOverviewParent,
            },
            {
                path: `${path}/simple/:venueId/:actId/:termId/:sessionId`,
                name: "Simple event series",
                component: EventSeriesParent,
            },
        ],
    },
    {
        path: `${path}/services`,
        name: "Services",
        component: Main,
        children: [
            {
                path: ":venueId",
                name: "Simple service",
                component: ServiceVenueOverviewParent,
            },
            {
                path: `${path}/services/:venueId/:actId/:termId/:sessionId`,
                name: "Simple service series",
                component: EventSeriesParent,
            },
        ],
    },
];

const mpRouter = createRouter({
    history: createWebHistory(),
    routes,
    strict: true,
});

export default mpRouter;
